/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import DbBaseObject from "@shared/DbBaseObject";
import {Type} from "@qwoach/class-transformer-wrapper";
import QuoteItem from "@shared/Quote/QuoteItem";

export const QUOTE_TEMPLATE_ID = "--quoteTemplate--"

export default class QuoteTemplateItem extends DbBaseObject {

	@Type(() => QuoteItem)
	quoteItem: QuoteItem = new QuoteItem();

	constructor(options = {}) {
		super(options);
		this.applyOptions(options);
	}

	getCurrentSchemaVersion() {
		return 6
	}

	regenerateId() {
		this.id = QUOTE_TEMPLATE_ID
		return this
	}

	migrateSchema(oldVersion, newVersion) {
		super.migrateSchema(oldVersion, newVersion)
		if (oldVersion < 2) {
			this.quoteItem?.migrateTitles?.()
		}
		if (oldVersion < 3) {
			this.quoteItem?.ensureServiceStructureMetadata?.()
		}
			if (oldVersion < 4) {
				this.quoteItem?.migrateRelatedServiceModel?.()
				this.quoteItem?.resetCommissionSpecificDistanceTemplateData?.()
				this.quoteItem?.cleanupLegacyEmptyStandaloneTravelTemplateServices?.()
			}
			if (oldVersion < 5) {
				this.quoteItem?.migrateLegacySectionIds?.()
			}
			if (oldVersion < 6) {
				this.quoteItem?.migrateSessionServices?.()
			}
		}

	static createDefault(userProfile = null) {
		let templateItem = new QuoteTemplateItem()
		templateItem.setQuoteItem(QuoteItem.createDefaultTemplateQuote(userProfile))
		return templateItem
	}

	static createFromQuoteItem(quoteItem) {
		let templateItem = new QuoteTemplateItem()
		templateItem.setQuoteItem(quoteItem)
		return templateItem
	}

	setQuoteItem(quoteItem) {
		this.quoteItem = quoteItem?.cloneForTemplate?.() || QuoteItem.createDefaultTemplateQuote()
		this.updatedAt = Date.now()
		return this
	}

	getQuoteItemClone() {
		return this.quoteItem?.cloneForTemplate?.() || QuoteItem.createDefaultTemplateQuote()
	}
}
